import { H5 } from '@atlassian/mpac-primitives';
import { TEST_ID } from '../constants';
import { Section } from '../Section';
import { BugBountyProgram } from './BugBountyProgram';
import { IntegrationDetails } from './IntegrationDetails';
import { PrivacyPolicy } from './PrivacyPolicyInfo';
import { PrivacySecurityQuestionnaireStatus } from './PrivacySecurityQuestionnaireStatus';
import { InfoList, SubSection } from './styles';
import { TrustCenterInfo } from './TrustCenterInfo';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PrivacyAndSecurity = props => {
  const {
    appName,
    appScopes,
    showSecurityProgramSection = true,
    bugBountyParticipant,
    hosting,
    partnerType,
    privacyPolicyUrl,
    privacySecurityQuestionsState,
    showIntegrationsDetailsSection,
    trustCenterUrl,
    permissionsJustification
  } = props;
  return /*#__PURE__*/_jsxs(Section, {
    "data-testid": TEST_ID.OVERVIEW_TAB_PRIVACY_AND_SECURITY,
    children: [/*#__PURE__*/_jsxs(SubSection, {
      children: [/*#__PURE__*/_jsx(Section.Heading, {
        as: "h2",
        children: "Privacy and Security"
      }), /*#__PURE__*/_jsx(PrivacySecurityQuestionnaireStatus, {
        privacySecurityQuestionsState: privacySecurityQuestionsState
      })]
    }), /*#__PURE__*/_jsxs(SubSection, {
      children: [/*#__PURE__*/_jsx(H5, {
        as: "h4",
        children: "Privacy policy"
      }), /*#__PURE__*/_jsx(InfoList, {
        children: /*#__PURE__*/_jsx(PrivacyPolicy, {
          privacyPolicyUrl: privacyPolicyUrl,
          partnerType: partnerType
        })
      })]
    }), showSecurityProgramSection && /*#__PURE__*/_jsxs(SubSection, {
      children: [/*#__PURE__*/_jsx(H5, {
        as: "h4",
        children: "Security program"
      }), /*#__PURE__*/_jsx(InfoList, {
        children: /*#__PURE__*/_jsx(BugBountyProgram, {
          hosting: hosting,
          bugBountyParticipant: bugBountyParticipant
        })
      })]
    }), /*#__PURE__*/_jsx(TrustCenterInfo, {
      trustCenterUrl: trustCenterUrl
    }), showIntegrationsDetailsSection && /*#__PURE__*/_jsx(IntegrationDetails, {
      appName: appName,
      appScopes: appScopes,
      permissionsJustification: permissionsJustification
    })]
  });
};